import 'vue';
import './helpers.js';
import './config.js';
import { b as registerComponent } from './plugins-6a50b8eb.js';
import './Icon-ea600614.js';
import './CheckRadioMixin-e92bd753.js';
import { s as script } from './Checkbox-906ca9dc.js';
export { s as OCheckbox } from './Checkbox-906ca9dc.js';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
